import React, { useEffect, useState } from "react";
import POCTable from "./common/POCTable";
import StatusCards from "./common/StatusCards";
import PaymentLink from "./common/PaymentLink";
import { Box, Grid, Stack, CircularProgress } from "@mui/material";
import CampaignsList from "./common/CampaignsList";
import CategoryCards from "./CategoryCards";
import {
  latestPaymentCampaign,
  paymentCampaign,
} from "../../services/paymentportalservice";

export default function Home() {
  const [stats, setStats] = useState({
    totalCampaign: 0,
    totalVendor: 0,
    totalLink: 0,
    totalSubordinates: 0,
    totalPending: 0,
    totalApplied: 0,
    totalFailed: 0,
    totalRejected: 0,
    totalSuccess: 0,
    totalWaiting: 0,
    totalBrand: 0,
  });
  const [subordinates, setSubordinates] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [campaignsLoading, setCampaignsLoading] = useState(true);
  const [topPayments, setTopPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await paymentCampaign();

      if (response && response.stats) {
        setStats({
          totalCampaign: response.stats.totalCampaign || 0,
          totalVendor: response.stats.totalCompany || 0,
          totalLink: response.stats.totalLink || 0,
          totalSubordinates: response.stats.totalSubordinates || 0,
          totalPending: response.stats.totalPending || 0,
          totalApplied: response.stats.totalApplied || 0,
          totalFailed: response.stats.totalFailed || 0,
          totalRejected: response.stats.totalRejected || 0,
          totalSuccess: response.stats.totalSuccess || 0,
          totalBrand: response.stats.totalBrand || 0,

          totalWaiting: 0,
        });

        setSubordinates(response.subordinates || []);
        setTopPayments(response.top10payment || []);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLatestCampaigns = async () => {
    try {
      setCampaignsLoading(true);
      const response = await latestPaymentCampaign();

      if (response && Array.isArray(response)) {
        setCampaigns(response);
      } else if (
        response &&
        response.campaigns &&
        Array.isArray(response.campaigns)
      ) {
        setCampaigns(response.campaigns);
      } else if (response && response.data && Array.isArray(response.data)) {
        setCampaigns(response.data);
      } else {
        setCampaigns([]);
      }
    } catch (error) {
      console.error("Error fetching campaigns:", error);
      setCampaigns([]);
    } finally {
      setCampaignsLoading(false);
    }
  };

  const updateLatestCampaign = (newCampaign) => {
    if (newCampaign && newCampaign.createdby) {
      const campaignWithUser = {
        ...newCampaign,
        user: [newCampaign.createdby.fullName],
      };
      setCampaigns((prevCampaigns) => [campaignWithUser, ...prevCampaigns]);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchLatestCampaigns();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <div>
      <Box
        width={{ xs: "100%", lg: `calc(100% - 80px)` }}
        marginLeft={{ xs: "0px", lg: `80px` }}
        marginTop={8}
        paddingTop={1}
        backgroundColor={"#f0f2f5"}
      >
        <Box sx={{ padding: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={9}>
              <Box sx={{ width: "100%" }}>
                <Stack spacing={4}>
                  <CategoryCards
                    totalCampaign={stats.totalCampaign}
                    totalVendor={stats.totalVendor}
                    updateLatestCampaign={updateLatestCampaign}
                    totalBrand={stats.totalBrand}
                  />
                  <StatusCards stats={stats} />
                  {subordinates.length > 0 && (
                    <POCTable subordinates={subordinates} />
                  )}
                  {topPayments.length > 0 && (
                    <PaymentLink topPayments={topPayments} />
                  )}
                </Stack>
              </Box>
            </Grid>

            <CampaignsList loading={campaignsLoading} campaigns={campaigns} />
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
